// Helper to replace deprecated InteractionManager.runAfterInteractions
// Uses requestIdleCallback when available, with sensible fallbacks.

export default function runAfterInteractions(task, { timeout = 50 } = {}) {
  if (typeof task !== 'function') return null;

  if (typeof global !== 'undefined' && typeof global.requestIdleCallback === 'function') {
    return global.requestIdleCallback(task, { timeout });
  }

  if (typeof setImmediate === 'function') {
    return setImmediate(task);
  }

  if (typeof global !== 'undefined' && typeof global.requestAnimationFrame === 'function') {
    return global.requestAnimationFrame(task);
  }

  return setTimeout(task, 0);
}

export function cancelRun(handle) {
  if (!handle) return;

  if (typeof global !== 'undefined' && typeof global.cancelIdleCallback === 'function') {
    return global.cancelIdleCallback(handle);
  }

  if (typeof clearImmediate === 'function') {
    return clearImmediate(handle);
  }

  if (typeof cancelAnimationFrame === 'function') {
    return cancelAnimationFrame(handle);
  }

  clearTimeout(handle);
}
